<div *ngIf="mismatchedRecordDetailsModel" class="data-tracking-container">
  <div class="flex items-center back-btn" (click)="onClickBack()">
    <i class="fa-solid fa-arrow-left"></i>&nbsp; Go Back
  </div>
  <div class="details-container m-b-20">
    <div class="flex flex-col items-start justify-start">
     <h5 class="flex items-center font-medium">Details</h5>

      <table class="data-table">
        <tbody>
          <tr>
            <td class="title">Worksheet:</td>
            <td> <span class="value" matTooltip="{{worksheetName}}">{{worksheetName}}</span></td>
          </tr>
          <tr>
            <td class="title" >Calculator:</td>
            <td> <span class="value" matTooltip="{{mismatchedRecordDetailsModel.mismatchedDetails.countryName}}">{{mismatchedRecordDetailsModel.mismatchedDetails.countryName}}</span></td>
          </tr>
          <tr *ngFor="let fieldDetail of mismatchedRecordDetailsModel.recordDetails">
            <td class="title">{{fieldDetail.fieldName}}:</td>
            <td> <span class="value" matTooltip="{{fieldDetail.fieldValue}}">{{fieldDetail.fieldValue}}</span></td>
          </tr>
          <tr>
            <td class="title">Field Name:</td>
            <td> <span class="value" matTooltip="{{mismatchedRecordDetailsModel.mismatchedDetails?.fieldName}}">{{mismatchedRecordDetailsModel.mismatchedDetails?.fieldName}}</span></td>
          </tr>
          <tr>
            <td class="title" >Value:</td>
            <td>
              <div class=" flex justify-between items-center">
              <span class="value" style="max-width: 160px;" matTooltip="{{mismatchedRecordDetailsModel.mismatchedDetails.value}}">
                {{mismatchedRecordDetailsModel.mismatchedDetails.value}}
              </span>
                <i class="fa-regular fa-arrow-up-right-from-square pointer m-r-15" matTooltip="Navigate to Source" (click)="navigateToScenarioCalculator(mismatchedRecordDetailsModel.mismatchedDetails)"></i>
              </div>
            </td>
          </tr>
        </tbody>
    </table>
  </div>

</div>
  <div class="details-container m-b-20">
    <div class="flex flex-col items-start justify-start">
      <h5 class="flex items-center font-medium">Mismatches</h5>

      <table class="data-table">
        <tbody>
        <tr *ngFor="let qnrRecord of qnrRecords">
          <td class="title"> <span matTooltip="{{qnrRecord.fieldValues['QnrTitle']}}.qnr">{{qnrRecord.fieldValues['QnrTitle']}}.qnr</span></td>
          <td>
            <div class=" flex justify-between items-center">
              <span class="value mismatched" matTooltip="{{qnrRecord.value}}">
                {{qnrRecord.value}}
              </span>
              <i class="fa-regular fa-arrow-up-right-from-square pointer m-r-15" matTooltip="Navigate to Source" (click)="navigateToCalculator(qnrRecord)"></i>
            </div>
          </td>
        </tr>
        <tr *ngFor="let calculatorRecord of calculatorsRecords">
          <td class="title"> <span matTooltip="{{calculatorRecord.countryName}}">{{calculatorRecord.countryName}}</span></td>
          <td>
            <div class=" flex justify-between items-center">
              <span class="value mismatched" matTooltip="{{calculatorRecord.value}}">
                {{calculatorRecord.value}}
              </span>
              <i class="fa-regular fa-arrow-up-right-from-square pointer m-r-15" matTooltip="Navigate to Source" (click)="navigateToCalculator(calculatorRecord)"></i>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>

  </div>

</div>
<div *ngIf="!mismatchedRecordDetailsModel && !isLoading" class="flex flex-col">
  <div class="flex flex-row">
    <i (click)="onClickBack()" class="fa-regular fa-arrow-left-long m-r-5 pointer"></i>
  </div>
<div class="flex flex-row">
  No diagnostics report available for this cell.
</div>
</div>
<div *ngIf="!mismatchedRecordDetailsModel && isLoading" class="flex flex-col">
  <div class="flex flex-row">
    <i (click)="onClickBack()" class="fa-regular fa-arrow-left-long m-r-5 pointer"></i>
  </div>
  <div class="flex flex-row">
    Loading diagnostics report...
  </div>
</div>
